import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import SecureLS from "secure-ls";
import dayjs from "dayjs";

const ls = new SecureLS({ encodingType: "aes" });

const HandleArchiveItem = ({ item, onClose, onArchiveConfirm }) => {
  const handleConfirmArchive = () => {
    const storedInventory = ls.get("localDB_inventory") || { items: [] };

    const updatedInventory = storedInventory.items.filter(
      (inventoryItem) => inventoryItem !== item
    );

    storedInventory.items = updatedInventory;
    ls.set("localDB_inventory", storedInventory);

    const storedArchive = ls.get("localDB_archivedInv") || { items: [] };
    storedArchive.items = [...storedArchive.items, item];
    ls.set("localDB_archivedInv", storedArchive);

    const newLog = {
      name: item.name,
      deliveryDate: item.deliveryDate,
      expiryDate: item.expiryDate,
      dateModified: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      action: "Archived",
    };
    storedInventory.history = [...(storedInventory.history || []), newLog];
    ls.set("localDB_inventory", storedInventory);

    onArchiveConfirm();
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth>
      <DialogTitle>Archive Inventory Item</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to archive <strong>{item.name}</strong>? This
          action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleConfirmArchive} color="primary">
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HandleArchiveItem;
